import { useAuth } from '../../utils/Auth';
import { useLocation, Outlet, Navigate } from 'react-router';
import LoadingSpinner from '../LoadingSpinner';

export default function AuthGuard({ children }) {
    const { currentUser, orgObj, isLoading, loadingState } = useAuth();
    const location = useLocation();
    
    // Only show loading spinner during initial auth/user/org load
    // Don't block UI for background updates (org data changes after initial load)
    const shouldShowLoader = isLoading && (
        loadingState.auth || 
        loadingState.user === 'loading'
    );
    
    if (shouldShowLoader) {
        return <LoadingSpinner />;
    }
    
    // If user has errors loading critical data, still try to show content
    // (org and user errors might be temporary network issues)
    const hasCriticalError = loadingState.user === 'error';
    
    // User is authenticated and has required data (or non-blocking errors)
    if (currentUser && (orgObj || !hasCriticalError)) {
      return children ? children : <Outlet />;
    }

    // No authenticated user, redirect to auth login while preserving search params
    const params = new URLSearchParams(location.search);
    params.set('mode', 'login');
    return <Navigate to={`/auth?${params.toString()}`} />;
};
